import React from "react";

const IPSkeleton = () => {
    const postAmount = 4;
    return (
        <>
            {[...Array(postAmount)].map((_, index) => (
                <div className="col-12 p-0" key={index}>
                    <div className="ec-card__wrap">
                        <div className="ec-ip__ncard">
                            <div className="ec-ip__ncard-header d-flex justify-content-between">
                                <div className="ec-ip__ncard-header-left d-flex">
                                    <div className="skeleton-circle mr-3" />
                                    
                                    <div className="ec-ip__ncard-header-data">
                                        <div className="skeleton-line-sm" />
                                        
                                        <div className="ec-ip__ncard-header-data-rating d-flex align-items-center">
                                            <div className="skeleton-line-sm" />
                                            <div className="skeleton-line-xs ml-2 mr-2" />
                                            <div className="skeleton-line-xs" />
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="ec-ip__ncard-header-right">
                                    <div className="skeleton-line-sm" />
                                    <div className="ec-ip__ncard-header-bid-blurb ec-nproject__bid-blurb mt-1">
                                        <div className="skeleton-line-xs" />
                                    </div>
                                </div>
                            </div>
                            
                            <div className="ec-ip__ncard__footer d-flex justify-content-end mt-5">
                                <div className="skeleton-button-sm mr-2" />
                                <div className="skeleton-button-lg" />
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </>
    );
};

export default IPSkeleton;

